import { Button } from "react-bootstrap";
import styled from "styled-components";

const StyledButton = styled(Button).attrs((props) => ({
  primary: props.variant === "primary" ? "true" : undefined,
}))`
  boxshadow: 0 3px 10px rgb(0 0 0 / 0.2);
  border-color: ${(props) => (props.primary ? "#222c4a" : null)};
  background-color: ${(props) => (props.primary ? "#222c4a" : null)};

  ${(props) =>
    props.primary &&
    `  :disabled {
      color: #fff;
      background-color: rgb(34, 44, 74, 0.9);
      border-color: rgb(34, 44, 74, 0.9);
    }
    
    :hover {
      background-color: #394c86;
    }
    
    :focus,
    :active {
      background-color: #222c4a;
    box-shadow: none;
    border-color: #222c4a;
  }`}
`;

type ButtomComponentProps = {
  type?: string;
  disabled?: boolean;
  hidden?: boolean;
  onClick?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  variant?: string;
  children?: React.ReactNode | JSX.Element;
  refProps?: null | HTMLInputElement;
  [x: string]: any; //all the other props (e.g. size)
};

const ButtonComponent = ({
  type,
  disabled,
  hidden,
  onClick,
  variant,
  children,
  refProps,
  ...rest
}: ButtomComponentProps) => {
  return (
    <StyledButton
      type={type}
      disabled={disabled}
      onClick={onClick ? (e: any) => onClick(e) : null}
      hidden={hidden}
      variant={variant ? variant : "primary"}
      ref={refProps}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default ButtonComponent;
